import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { AppPipesModule } from '../app-pipes/app-pipes.module';
import { CommonModule } from '@angular/common';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu'; // had to import it in this module as well for whatever reason...
import { NgMapsCoreModule } from '@ng-maps/core';
import { NgMapsMarkerClustererModule } from '@ng-maps/marker-clusterer';
import { CreateViewBaseProjectComponent } from '../../pages/projects/client-corner/create-view-base-project/create-view-base-project.component';
import { ContactPickerComponent } from '../../shared/contact-picker/contact-picker.component';
import { ExtraCompanyContactPicker } from '../../shared/contact-picker/extra-company-contact-picker/extra-company-contact-picker.component';
import { WindowstickerMaterialPickerComponent } from '../../shared/project-components/windowsticker/windowsticker-material-picker/windowsticker-material-picker.component';
import { GeneralInternalAdjustmentComponent } from '../../components/adjustments/edit-ip-adjustment/general-internal-adjustment/general-internal-adjustment-component';
import { ExternalSupplierComponent } from '../../shared/project-components/helpers/external-supplier/external-supplier.component';
import { AdminPlanningContainerComponent } from '../../pages/planning/admin-planning-container/admin-planning-container.component';
import { DailyPlanningOverviewComponent } from '../../pages/planning/admin-planning-container/daily-planning-overview/daily-planning-overview.component';
import { AdminPlanningMapComponent } from '../../pages/planning/admin-planning-container/admin-planning-map/admin-planning-map.component';
import { AdminPlanningMarkerPopupComponent } from '../../pages/planning/admin-planning-container/admin-planning-map/markers/admin-planning-marker-popup/admin-planning-marker-popup.component';
import { AdminPlanningMarkerProjectInfoComponent } from '../../pages/planning/admin-planning-container/admin-planning-map/markers/admin-planning-marker-project-info/admin-planning-marker-project-info.component';
import { DailyPlanningMapComponent } from '../../pages/planning/admin-planning-container/daily-planning-overview/daily-planning-map/daily-planning-map.component';
import { WindowstickerComponent } from '../../shared/project-components/windowsticker/windowsticker.component';
import { CustomWindowStickerComponent } from '../../shared/project-components/windowsticker/custom-window-sticker/custom-window-sticker.component';
import { SizePickerComponent } from '../../shared/project-components/helpers/size-picker/size-picker.component';
import { ProjectSummaryComponent } from '../../pages/projects/project-summary/project-summary.component';
import { BoardPriceSummaryComponent } from '../../pages/projects/helpers/board-summary-card/board-price-summary/board-price-summary.component';
import { MostRecentPlacementOverviewComponent } from '../../pages/projects/most-recent-placement/most-recent-placement-overview.component';
import { MostRecentPlacementItemComponent } from '../../pages/projects/most-recent-placement/most-recent-placement-item/most-recent-placement-item.component';
import { ProductPriceSummaryComponent } from '../../pages/projects/project-summary/product-price-summary/product-price-summary.component';
import { LoadTaskPlacerFormComponent } from '../../pages/projects/placer/load-task-placer-form/load-task-placer-form.component';
import { LoadListTableComponent } from '../../pages/projects/placer/load-task-placer-form/load-list-table/load-list-table.component';
import { OtherTaskPlacerFormComponent } from '../../pages/projects/placer/other-task-placer-form/other-task-placer-form.component';
import { ClientSignStockWarningComponent } from '../../shared/project-components/client-project-form/base-project/client-ip-board-form/client-sign-selector/client-sign-stock-warning/client-sign-stock-warning.component';
import { ClientOrderStockComponent } from '../../shared/project-components/client-project-form/base-project/client-ip-board-form/client-sign-selector/client-order-stock/client-order-stock.component';
import { ClientNoStockComponent } from '../../shared/project-components/client-project-form/base-project/client-ip-board-form/client-sign-selector/client-no-stock/client-no-stock.component';
import { IPBoardPartAbbreviationSelectorComponent } from '../../shared/project-components/helpers/ip-board-design-picker/ip-board-text-input/ip-board-part-abbreviation-selector/ip-board-part-abbreviation-selector.component';
import { ProductSummaryPickerComponent } from '../../pages/projects/helpers/product-summary-picker/product-summary-picker.component';
import { ProductPlacementSummaryComponent } from '../../components/product-placement-summary/product-placement-summary.component';
import { WindowstickerSummaryCardComponent } from '../../pages/projects/helpers/windowsticker-summary-picker/windowsticker-summary-card.component';
import { BoardSummaryCardComponent } from '../../pages/projects/helpers/board-summary-card/board-summary-card.component';
import { OtherProductSummaryCardComponent } from '../../pages/projects/helpers/other-product-summary-card/other-product-summary-card.component';
import { ClientBaseProjectSummaryComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-base-project-summary.component';
import { ClientWindowStickerSummaryComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-window-sticker-summary/client-window-sticker-summary.component';
import { ClientBoardSummaryComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-board-summary/client-board-summary.component';
import { ClientIPBoardSummaryComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-ip-board-summary/client-ip-board-summary.component';
import { ClientOtherProductSummaryComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-other-product-summary/client-other-product-summary.component';
import { ClientNonIPBoardDesignSummaryComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-non-ip-board-design-summary/client-non-ip-board-design-summary.component';
import { EditIPBoardProjectComponent } from '../../pages/projects/edit-ip-board-project/edit-ip-board-project.component';
import { InvoicePreviewComponent } from '../../components/invoice/invoice-preview/invoice-preview.component';
import { PlacementInvoiceComponent } from '../../pages/projects/helpers/invoicing/placement-invoice/placement-invoice.component';
import { CompanyInvoiceComponent } from '../../pages/projects/helpers/invoicing/company-invoice/company-invoice.component';
import { BoardPlacementPriceComponent } from '../../pages/projects/helpers/invoicing/placement-invoice/board-placement-price/board-placement-price.component';
import { IPBoardOnHoldDialogComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/dialog/ip-board-on-hold-dialog/ip-board-on-hold-dialog.component';
import { IPBoardDesignDialogComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/dialog/ip-board-design-dialog/ip-board-design-dialog.component';
import { IPBoardExtraDesignComponent } from '../../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-ip-board-summary/ip-board-extra-design/ip-board-extra-design.component';
import { ClientProjectFormSummaryBanner } from '../../shared/project-components/client-project-form/client-project-form-summary-banner/client-project-form-summary-banner.component';
import { IPBoardPrintworkDialogComponent } from 'src/app/pages/projects/client-corner/create-view-base-project/client-base-project-summary/dialog/ip-board-printwork-dialog/ip-board-printwork-dialog.component';
import { ClientSubProjectDesignContentComponent } from 'src/app/pages/client-corner/client-project-detail/client-sub-project-design/client-sub-project-design-content/client-sub-project-design-content.component';
import { ClientSubProjectDesignCollapseComponent } from 'src/app/pages/client-corner/client-project-detail/client-sub-project-design/client-sub-project-design-collapse/client-sub-project-design-collapse.component';
import { SearchSubProjectsInputComponent } from 'src/app/pages/search-subprojects/input/search-subprojects-input.component';
import { SearchSubProjectsResultComponent } from 'src/app/pages/search-subprojects/result/search-subprojects-result.component';
import { CreateOldSystemImmoProjectComponent } from 'src/app/pages/projects/create-old-system-immo-project/create-old-system-immo-project.component';
import { PlanningShortcutComponent } from 'src/app/pages/projects/overview/projects-table/planning-shortcut/planning-shortcut.component';
import { ClientSignStockThanksComponent } from '../../shared/project-components/client-project-form/base-project/client-ip-board-form/client-sign-selector/client-sign-stock-thanks/client-sign-stock-thanks.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { NgMapsGoogleModule } from '@ng-maps/google';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    SharedModule,
    MatPaginatorModule,
    NgMapsCoreModule,
    NgMapsMarkerClustererModule,
    AppPipesModule,
    MatSelectModule,
    NgMapsGoogleModule,
  ],
  exports: [
    CreateViewBaseProjectComponent,
    ContactPickerComponent,
    ExtraCompanyContactPicker,
    WindowstickerMaterialPickerComponent,
    GeneralInternalAdjustmentComponent,
    ExternalSupplierComponent,
    AdminPlanningContainerComponent,
    DailyPlanningOverviewComponent,
    AdminPlanningMapComponent,
    AdminPlanningMarkerPopupComponent,
    AdminPlanningMarkerProjectInfoComponent,
    DailyPlanningMapComponent,
    WindowstickerComponent,
    CustomWindowStickerComponent,
    SizePickerComponent,
    ProjectSummaryComponent,
    BoardPriceSummaryComponent,
    MostRecentPlacementOverviewComponent,
    MostRecentPlacementItemComponent,
    ProductPriceSummaryComponent,
    LoadTaskPlacerFormComponent,
    LoadListTableComponent,
    OtherTaskPlacerFormComponent,
    ClientSignStockWarningComponent,
    ClientNoStockComponent,
    ClientOrderStockComponent,
    IPBoardPartAbbreviationSelectorComponent,
    ProductSummaryPickerComponent,
    ProductPlacementSummaryComponent,
    WindowstickerSummaryCardComponent,
    BoardSummaryCardComponent,
    OtherProductSummaryCardComponent,
    ClientBaseProjectSummaryComponent,
    ClientWindowStickerSummaryComponent,
    ClientBoardSummaryComponent,
    ClientIPBoardSummaryComponent,
    ClientOtherProductSummaryComponent,
    ClientNonIPBoardDesignSummaryComponent,
    EditIPBoardProjectComponent,
    InvoicePreviewComponent,
    PlacementInvoiceComponent,
    CompanyInvoiceComponent,
    BoardPlacementPriceComponent,
    IPBoardOnHoldDialogComponent,
    IPBoardDesignDialogComponent,
    IPBoardExtraDesignComponent,
    ClientProjectFormSummaryBanner,
    IPBoardPrintworkDialogComponent,
    ClientSubProjectDesignContentComponent,
    ClientSubProjectDesignCollapseComponent,
    SearchSubProjectsInputComponent,
    SearchSubProjectsResultComponent,
    CreateOldSystemImmoProjectComponent,
    PlanningShortcutComponent,
    ClientSignStockThanksComponent,
  ],
  declarations: [
    CreateViewBaseProjectComponent,
    ContactPickerComponent,
    ExtraCompanyContactPicker,
    WindowstickerMaterialPickerComponent,
    GeneralInternalAdjustmentComponent,
    ExternalSupplierComponent,
    AdminPlanningContainerComponent,
    DailyPlanningOverviewComponent,
    AdminPlanningMapComponent,
    AdminPlanningMarkerPopupComponent,
    AdminPlanningMarkerProjectInfoComponent,
    DailyPlanningMapComponent,
    WindowstickerComponent,
    CustomWindowStickerComponent,
    SizePickerComponent,
    ProjectSummaryComponent,
    BoardPriceSummaryComponent,
    MostRecentPlacementOverviewComponent,
    MostRecentPlacementItemComponent,
    ProductPriceSummaryComponent,
    LoadTaskPlacerFormComponent,
    LoadListTableComponent,
    OtherTaskPlacerFormComponent,
    ClientSignStockWarningComponent,
    ClientNoStockComponent,
    ClientOrderStockComponent,
    IPBoardPartAbbreviationSelectorComponent,
    ProductSummaryPickerComponent,
    ProductPlacementSummaryComponent,
    WindowstickerSummaryCardComponent,
    BoardSummaryCardComponent,
    OtherProductSummaryCardComponent,
    ClientBaseProjectSummaryComponent,
    ClientWindowStickerSummaryComponent,
    ClientBoardSummaryComponent,
    ClientIPBoardSummaryComponent,
    ClientOtherProductSummaryComponent,
    ClientNonIPBoardDesignSummaryComponent,
    EditIPBoardProjectComponent,
    InvoicePreviewComponent,
    PlacementInvoiceComponent,
    CompanyInvoiceComponent,
    BoardPlacementPriceComponent,
    IPBoardOnHoldDialogComponent,
    IPBoardDesignDialogComponent,
    IPBoardExtraDesignComponent,
    ClientProjectFormSummaryBanner,
    IPBoardPrintworkDialogComponent,
    ClientSubProjectDesignContentComponent,
    ClientSubProjectDesignCollapseComponent,
    SearchSubProjectsInputComponent,
    SearchSubProjectsResultComponent,
    CreateOldSystemImmoProjectComponent,
    PlanningShortcutComponent,
    ClientSignStockThanksComponent,
  ],
})
export class ProjectsModule {}
